if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.hideImagePreview = this.hideImagePreview.bind(this);
      this.addEventListener('pointerover', event => {
        if (event.pointerType === 'touch' || !window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
        const media = event.target.closest('[data-preview-image]');
        if (media && !media.contains(event.relatedTarget)) this.showImagePreview(media);
      });
      this.addEventListener('pointerout', event => {
        const media = event.target.closest('[data-preview-image]');
        if (media && !media.contains(event.relatedTarget)) this.hideImagePreview();
      });
      this.addEventListener('focusin', event => {
        if (event.target.matches('[data-preview-image]')) this.showImagePreview(event.target);
      });
      this.addEventListener('focusout', this.hideImagePreview);
      this.addEventListener('click', this.hideImagePreview);
    }

    connectedCallback() {
      // Wait until the custom element's child markup is available.
      requestAnimationFrame(() => { if (this.isConnected) this.performRecommendations(); });
      if (this.dataset.recommendationArea === 'product') {
        this.cartRefresh = () => this.performRecommendations();
        document.addEventListener('shevi:cart-updated', this.cartRefresh);
      }
    }

    disconnectedCallback() {
      this.hideImagePreview();
      if (this.cartRefresh) document.removeEventListener('shevi:cart-updated', this.cartRefresh);
    }

    showImagePreview(media) {
      this.hideImagePreview();
      const rect = media.getBoundingClientRect();
      const above = rect.top - 12;
      const below = window.innerHeight - rect.bottom - 12;
      const placeAbove = above >= 120 || above >= below;
      const space = placeAbove ? above : below;
      const size = Math.min(280, window.innerWidth - 24, space - 8);
      if (size < 80) return;
      const preview = document.createElement('div');
      preview.className = 'shevi-recommendation-preview';
      preview.setAttribute('aria-hidden', 'true');
      const image = document.createElement('img');
      image.src = media.dataset.previewImage;
      image.alt = '';
      preview.append(image);
      preview.style.width = size + 'px';
      preview.style.height = size + 'px';
      preview.style.left = Math.max(12, Math.min(rect.left + rect.width / 2 - size / 2, window.innerWidth - size - 12)) + 'px';
      preview.style.top = (placeAbove ? rect.top - size - 10 : rect.bottom + 10) + 'px';
      document.body.append(preview);
      this.imagePreview = preview;
      window.addEventListener('scroll', this.hideImagePreview, true);
      window.addEventListener('resize', this.hideImagePreview);
      this.previewEscape = event => { if (event.key === 'Escape') this.hideImagePreview(); };
      document.addEventListener('keydown', this.previewEscape);
    }

    hideImagePreview() {
      this.imagePreview?.remove();
      this.imagePreview = null;
      window.removeEventListener('scroll', this.hideImagePreview, true);
      window.removeEventListener('resize', this.hideImagePreview);
      if (this.previewEscape) document.removeEventListener('keydown', this.previewEscape);
    }

    performRecommendations() {
      const recommendations = this.querySelector(
        '[data-recommendations]'
      );
      if (!recommendations) return;
      const requestId = this.requestId = (this.requestId || 0) + 1;
      const url = new URL(this.dataset.url, document.baseURI);
      url.searchParams.set('_shevi_refresh', Date.now());
      fetch(url, { cache: 'no-store' })
        .then(response => response.text())
        .then(text => {
          if (requestId !== this.requestId || !this.isConnected) return;
          const recommendationsHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('product-recommendations[data-recommendation-area="' + this.dataset.recommendationArea + '"] [data-recommendations]')?.innerHTML;
          if (!recommendationsHTML || !recommendationsHTML.includes('product-recommendations__item')) return;
          this.classList.remove('hidden');
          var cartDrawerItemsFull = document.querySelector('.cart-drawer-items__full');
          if(cartDrawerItemsFull) {
            cartDrawerItemsFull.classList.remove('cart-drawer-items__full');
          }
          this.hideImagePreview();
          recommendations.innerHTML = recommendationsHTML;
          this.initSlider();

          // initiate quick cart after fetch
          // to activate trigger button events
          setTimeout(() => {
            if (document.querySelector("quick-cart-drawer")) {
              document.querySelector("quick-cart-drawer").init();
            } else {
              // if quick-cart-drawer does not exists, remove trigger buttons
              this.querySelectorAll(".quick-cart-drawer__trigger").forEach(el => {
                el?.remove();
              })
            }
          }, 500);

        })
        .catch(() => { /* Keep the server-rendered cards; opening the cart can retry. */ });
    }

    initSlider() {
      // Compact complementary recommendations use a vertical list.
      if (this.closest('.product__complementaries') || ['cart', 'cart-drawer'].includes(this.dataset.recommendationArea)) return;
      this.slider = new Swiper(this.querySelector('.swiper'), {
        slidesPerView: 'auto',
        spaceBetween: 16,
      });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}
